import { createContext } from 'react';

import { IFetchPrivateStatsParams } from 'modules/stats/actions/fetchPrivateStats';
import { StatsTimeframe } from 'modules/stats/types';
import { ProjectStatsParams } from 'modules/projects/types';

const defaultParams: IFetchPrivateStatsParams = {
  timeframe: StatsTimeframe.Day,
  workerToken: '',
};

const defaultValue: ProjectStatsParams = {
  [StatsTimeframe.Hour]: defaultParams,
  [StatsTimeframe.Day]: defaultParams,
};

export const ProjectStatsContext = createContext(defaultValue);
